'use strict';
import * as angular from 'angular';

export module NgUtils {
    export interface IInjectableFunction extends FunctionConstructor {
        $inject: any[];
    }

    /**
     * Takes a class, wraps it in a factory function which produces a class instance where the scope of all its methods are bound to itself (this)
     * @param type class which has a static $inject:any[] property
     */
    export function Factory<T>(type: T): any[] {
        var t = (<IInjectableFunction>(<any>type));
        t.$inject = t.$inject || [];
        return t.$inject.concat((...args) => {
            var boundType = t.bind.apply(type, [null].concat(args));
            var instance = new boundType();
            for (var prop in instance) {
                var func = instance[prop];
                if (typeof (func) == "function" && t.$inject.indexOf(prop) == -1)
                    instance[prop] = func.bind(instance);
            }
            return instance;
        });
    }

    /**
     * Takes a string and recursively tries to resolve it using a given parse service and scope.
     * @param value Value to parse
     * @param $parse Parser to use
     * @param $scope Scope to use
     */
    export function ParseExpressionOrValue(value: string, $parse: angular.IParseService, $scope: angular.IScope) {
        try {
            var parsed = $parse(value)($scope);
            if (parsed !== undefined)
                return ParseExpressionOrValue(parsed, $parse, $scope);
        } catch (ex) {

        }
        return value;
    }

    export function DefineModule(moduleId: string, dependencies: string[]): angular.IModule {
        return angular.module(moduleId, dependencies);
    }
}